module.exports = __webpack_public_path__ + "img/20190923171958153.0c5479ff.jpg";